var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-chat" }, [
    _c("div", { staticClass: "c-chat__header" }, [
      _c("div", { staticClass: "left_wrap" }, [
        _c("span", { staticClass: "header-title" }, [
          _vm._v(
            _vm._s(
              _vm.chatSourceType === "wenshu"
                ? "AI问数"
                : _vm.chatSourceType === "global"
                ? "AI员工"
                : "AI面试顾问"
            )
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "right_wrap", on: { click: _vm.drawerOnClose } },
        [
          _c("img", {
            attrs: {
              src: require("@/components/aiChat/images/svg/shouqiIcon.svg"),
              alt: "",
            },
          }),
        ]
      ),
    ]),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.historyLoading,
            expression: "historyLoading",
          },
        ],
        staticClass: "c-chat__content",
      },
      [
        _vm.source !== "global"
          ? _c("div", { staticClass: "c-chat__title" }, [
              _c("img", {
                staticClass: "touxiang",
                attrs: {
                  src:
                    _vm.interview?.resume_00011?.showValue ||
                    require("@/assets/images/defaultPerson.png"),
                },
              }),
              _c("span", { staticStyle: { "margin-right": "10px" } }, [
                _vm._v(_vm._s(_vm.interview?.resume_00013?.showValue)),
              ]),
              _c(
                "p",
                [
                  _c("span", { staticStyle: { "margin-right": "10px" } }, [
                    _vm._v(_vm._s(_vm.interview.jobName)),
                  ]),
                  _vm._l(
                    _vm.interview.evaluateEntityList,
                    function (item, index) {
                      return _c(
                        "span",
                        { key: index, staticStyle: { "margin-right": "10px" } },
                        [
                          _vm._v(
                            " 面试官" +
                              _vm._s(index + 1) +
                              "：" +
                              _vm._s(item.userName) +
                              " "
                          ),
                        ]
                      )
                    }
                  ),
                ],
                2
              ),
            ])
          : _vm._e(),
        _vm.isRender
          ? _c("Main", {
              attrs: {
                widgetMenuFormDataModelProp: _vm.widgetMenuFormDataModel,
                activeRouteProp: _vm.activeRoute,
                suggestQuestionListProp: _vm.suggestQuestionList,
                formModelDataProp: _vm.formModelData,
                isDeepThinkingProp: _vm.isDeepThinking,
                isDisabledScrollProp: _vm.isDisabledScroll,
                paramsModelDataProp: _vm.paramsModelData,
                historyLoading: _vm.historyLoading,
                interviewProp: _vm.interview,
                source: _vm.source,
              },
              on: {
                "update:activeRouteProp": function ($event) {
                  _vm.activeRoute = $event
                },
                "update:active-route-prop": function ($event) {
                  _vm.activeRoute = $event
                },
                "update:isDeepThinkingProp": function ($event) {
                  _vm.isDeepThinking = $event
                },
                "update:is-deep-thinking-prop": function ($event) {
                  _vm.isDeepThinking = $event
                },
                "update:isDisabledScrollProp": function ($event) {
                  _vm.isDisabledScroll = $event
                },
                "update:is-disabled-scroll-prop": function ($event) {
                  _vm.isDisabledScroll = $event
                },
                "on-load-scroll": _vm.onLoadScroll,
                "on-query-dialogue": (e) => {
                  _vm.onCreate(e)
                },
                "on-stop-dialogue": _vm.onStopDialogue,
                "on-delete": _vm.onDelete,
                "on-sticky": _vm.onSticky,
                "on-un-sticky": _vm.onUnSticky,
                "on-reset-name": _vm.onResetName,
                "on-send-suggest-question": _vm.onSendSuggestQuestion,
                "on-reset-question": _vm.onResetQuestion,
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }